import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import arrowImage from '../../../../assets/img/innovation-jiantou.png';
import { GameMenuKey } from '../../../../model';
import {
  IAPIGameItem,
  IAPIUserInfo,
  IAPIServiceConfigItem,
  IApplyDataList,
} from '../../../../model/api-modules';
import { IGameEnvModel } from '../../../../model/api-modules/env';
import {
  getPathnameByGameInfo,
  formatGameParamsByLocationPathname,
} from '../../lib';
import {
  getObject,
  setObject,
} from '../../../../lib/local-storage/interface-base';
import { HelpCreateEnvModal } from '../../common/help-create-env-modal';
import { serviceOpenList, getServiceList } from '../../../../api/services';
import classNames from 'classnames';
// import { BatchApplyModal } from '../../overview/batch-apply-modal';
import './style.scss';
import getFormatMessage from '../../../../locales/get-format-message';
import { IRootState } from '../../../../store/reducers';
import { useSelector } from 'react-redux';
import { openContactMethod } from '../../../../lib/email';
import { BatchApplyDrawer } from '../../overview/batch-apply-drawer';

const STEP_DATA = [
  {
    step: 1,
    content: getFormatMessage('step_check_env_desc'),
    buttonText: getFormatMessage('check'),
  },
  {
    step: 2,
    content: getFormatMessage('step_apply_service_desc'),
    buttonText: getFormatMessage('batch_apply'),
  },
  {
    step: 3,
    content: getFormatMessage('step_sdk_contact_desc'),
    buttonText: getFormatMessage('go_to_download'),
  },
  {
    step: 4,
    content: getFormatMessage('step_obtain_configuration_information_desc'),
    buttonText: getFormatMessage('get'),
  },
  {
    step: 5,
    content: getFormatMessage('step_questions_contact_desc'),
    buttonText: getFormatMessage('contact_us_upper'),
  },
  {
    step: 6,
    content: getFormatMessage('step_launched_help_desc'),
    buttonText: getFormatMessage('contact_us_upper'),
  },
];

interface IProps {
  readonly selectedGame: IAPIGameItem;
  readonly envs: ReadonlyArray<IGameEnvModel>;
  readonly userInfo: IAPIUserInfo;
}

export const ServiceAccessStep = (props: IProps) => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [tipsModal, setTipsModal] = useState<boolean>(false);
  const [showCheckModal, setShowCheckModal] = useState<boolean>(false);
  const [showBatchApplyModal, setShowBatchApplyModal] =
    useState<boolean>(false);
  const [applyList, setApplyList] = useState<IApplyDataList[]>([]);
  const [openList, setOpenList] = useState<IAPIServiceConfigItem[]>([]);
  const [envID, setEnvID] = useState<number>();
  const { gameId, envId } = formatGameParamsByLocationPathname(
    location.pathname
  );
  const history = useHistory();
  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );
  console.log(applyList, openList);

  useEffect(() => {
    getServiceOpenList();
  }, [gameId, envId]);

  useEffect(() => {
    hasEnv();
  }, [props.selectedGame.gameID, location.pathname]);

  useEffect(() => {
    setObject(props.userInfo.id.toString(), currentStep);
  }, [currentStep]);

  const getServiceOpenList = async () => {
    if (gameId && envId) {
      const res = await serviceOpenList(gameId, Number(envId));
      const result = await getServiceList();
      if (res && result) {
        const showApplyList: IAPIServiceConfigItem[] =
          JSON.parse(JSON.stringify(result)) || [];
        res.length !== 0 &&
          res.map((item) => {
            const isOpenItem = result.find((it) => it.id === item.ServiceID);
            if (isOpenItem) {
              showApplyList.splice(showApplyList.indexOf(isOpenItem), 1);
            }
            return showApplyList;
          });
        const showClassifyList: string[] = [];
        showApplyList.map((item) => {
          if (showClassifyList.indexOf(item.ParentName) === -1) {
            showClassifyList.push(item.ParentName);
          }
          return showClassifyList;
        });
        const dataList: IApplyDataList[] = [];
        showClassifyList.map((item) => {
          const itemList: IAPIServiceConfigItem[] = [];
          showApplyList.map((it) => {
            if (item === it.ParentName) {
              itemList.push(it);
            }
            return itemList;
          });
          dataList.push({
            title: item,
            commonServices: itemList,
            checkedList: [],
            parentSort: itemList[0].ParentSort || 0,
          });
          return dataList;
        });
        dataList.sort((pre, next) => pre.parentSort - next.parentSort);
        setOpenList(result);
        setApplyList(dataList);
      }
    }
  };

  const handleNextStep = () => {
    switch (currentStep) {
      case 1:
        handleCheck();
        break;
      case 2:
        handleApply();
        break;
      case 3:
        handleToDownload();
        break;
      case 4:
        handleToConfig();
        break;
      default:
        openContactMethod();
        break;
    }
  };
  const handleCheck = () => {
    if (envID) {
      setCurrentStep(currentStep + 1);
    } else {
      setTipsModal(true);
      setShowCheckModal(true);
    }
  };
  const handleToDownload = () => {
    history.push(
      `/download/download-center?studioId=${selectStudio?.studioID}`
    );
  };
  // const handleOk = async () => {
  //   console.log('打开创建环境内容');
  //   setTipsModal(false);
  //   return true;
  // };
  const handleApply = () => {
    setShowBatchApplyModal(true);
  };
  const closeBatchApply = () => {
    setShowBatchApplyModal(false);
  };
  const onToRouter = (pathname: string) => {
    history.push(pathname);
  };
  const handleToConfig = () => {
    onToRouter(getPathnameByGameInfo(GameMenuKey.GameInfo));
  };

  const hasEnv = () => {
    // const gameId = props.selectedGame.gameID;
    const { envId } = formatGameParamsByLocationPathname(location.pathname);
    setEnvID(Number(envId));
    // 无环境，先到步骤一
    if (!envId) {
      setCurrentStep(1);
    } else {
      // 环境存在，保持之前的currentStep
      const storedStep = getObject<number>(props.userInfo.id.toString());
      if (storedStep) {
        setCurrentStep(storedStep);
      }
    }
  };

  const renderBatchApplyModal = () => {
    return (
      <>
        {envId && (
          <BatchApplyDrawer
            onClose={closeBatchApply}
            visible={showBatchApplyModal}
            gameId={gameId}
            envId={Number(envId)}
          />
        )}
      </>
    );
  };

  const renderTipsEnvModal = () => {
    if (tipsModal && props.selectedGame) {
      return (
        <HelpCreateEnvModal
          showCheckModal={showCheckModal}
          onCloseCheckModal={() => setShowCheckModal(false)}
          onClose={() => setTipsModal(false)}
          selectedGame={props.selectedGame}
        />
      );
    }
    return null;
  };

  const renderStep = (stepNumber: number, stepText: {} | null | undefined) => {
    const className = classNames('step-item', {
      selected: currentStep === stepNumber,
    });
    return (
      <div className="step">
        <div className={className} onClick={() => setCurrentStep(stepNumber)}>
          <div className="step-dot">
            <span className="step-number">{stepNumber}</span>
          </div>
          <div className="step-content">{stepText}</div>
        </div>
        {stepNumber !== STEP_DATA.length && (
          <img className="arrow" src={arrowImage} alt="Arrow" />
        )}
      </div>
    );
  };

  const renderContent = () => {
    const currentStepContent = STEP_DATA.find(
      (step) => step.step === currentStep
    );
    if (currentStepContent) {
      return (
        <div className="content-container">
          <div className="step-describe">{currentStepContent.content}</div>
          {/* {currentStep !== 2 && ( */}
          <button
            className="gc-btn gc-btn-primary btn-step"
            onClick={handleNextStep}
          >
            {currentStepContent.buttonText}
          </button>
          {/* )} */}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="step-container">
      <div className="step-text">
        {getFormatMessage('in_game_focus_on')}
        <span>{getFormatMessage('innovation')}</span>
      </div>
      <div className="steps-column">
        {renderStep(1, getFormatMessage('check_environment'))}
        {renderStep(2, getFormatMessage('apply_to_start'))}
        {renderStep(3, getFormatMessage('sdk_download'))}
        {renderStep(4, getFormatMessage('get_configuration'))}
        {renderStep(5, getFormatMessage('testing'))}
        {renderStep(6, getFormatMessage('go_live'))}
      </div>
      <div className="content-container">{renderContent()}</div>
      {renderTipsEnvModal()}
      {renderBatchApplyModal()}
    </div>
  );
};
